import { render, staticRenderFns } from "./brigad_ajiliin_bairnii_zar.vue?vue&type=template&id=0cac37d6&scoped=true&"
import script from "./brigad_ajiliin_bairnii_zar.vue?vue&type=script&lang=js&"
export * from "./brigad_ajiliin_bairnii_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac37d6",
  null
  
)

export default component.exports